import InfoTooltip from "../info-tooltip/InfoTooltip";
import { ReactNode } from "react";

type LabelWithTooltipProps = {
  label: ReactNode;
  tooltip: ReactNode;
};

/**
 * Helper which adds a tooltip to a label
 */
const LabelWithTooltip = ({ label, tooltip }: LabelWithTooltipProps) => {
  return (
    <>
      {label}
      <InfoTooltip className="ms-2" label={tooltip} />
    </>
  );
};

export default LabelWithTooltip;
